import { Component, OnInit, ViewChild } from '@angular/core';
import { HereJsService } from '../../services/here-js.service';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
})
export class LocationComponent implements OnInit {

  items; data;
  ctrl;

  query: string = '';

  public qResults = new Array<any>();

  public acs = [];

  @ViewChild('i', {static:true})i: any;
  
  constructor(
    private ac: HereJsService,
  ) {
  }

  ngOnInit() {}
  
  ngAfterViewInit() {
    setTimeout(() => {
      this.i.setFocus()
    }, 300);
  }

  async search(){
    let l = this.query.trim().length;
    if(!l || (l > 15 && l % 3 !== 0)) return;
    if(l < 5){
      this.qResults = [{description: 'Searching...'}]
    } else {
      let p = await this.ac.predict(this.query);
      return this.qResults = p;
    }
  }










  async close(r) {
    const func = this.items?.return||'address';
    let a: any = null; 
    a = this.ac[func](r);
    await this.ctrl.dismiss(a)
  }

}
